export const courseData = [
    "Data Structures and Algorithms",
    "Object Oriented Programming",
    "Web Development",
    "Operating Systems",
    "Robotics Algorithms",
    "Machine Learning",
    "Distributed Systems",
    "Computer Vision and Image Processing",
    "Graph Mining and Management",
    "Reinforcement Learning"
]